import './report-menu.scss'

import { defineComponent } from 'vue'
import { faCheck, faTimes, faExclamationTriangle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { ConditionReportRoutes } from '@skinsoft/const'
import { OfflineDataFetcher } from '@skinsoft/offline'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'
import {
    DELETE_CURRENT_REPORT_TOPIC,
    OPEN_CLOSE_REPORT_SCREEN_TOPIC,
    OPEN_PDF_OVERVIEW_TOPIC,
    OPEN_SIGNATURE_MODULE_TOPIC,
    SAVE_CURRENT_REPORT_TOPIC,
    DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC,
    DUPLICATE_CLOSED_REPORT_TOPIC,
    OPEN_COUNTER_SIGNATURE_MODULE_TOPIC,
} from '../../../busTopics'

export const ReportMenu = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./report-menu.html'),
    props: {
        reportId: { default: null },
        readOnly: {},
    },
    data() {
        return {
            isConfirmationDeleteReportVisible: false,
            isConfirmationDeleteUnsyncModifVisible: false,
            canEdit: true,
            // Icons
            crossIcon: faTimes,
            checkIcon: faCheck,
            warningIcon: faExclamationTriangle,
            loadingIcon: faCircleNotch,
            // Used to react to network connection changes
            isOnline: window.navigator.onLine,
            reportHasCachedUpdate: false,
        }
    },
    created() {
        window.addEventListener('offline', this.onConnectivityChange)
        window.addEventListener('online', this.onConnectivityChange)

        this.subscribeToBus(IMAGE_UPLOADED_TOPIC, this.onMediaStartLoading)
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, this.onMediaEndLoading)

        this.checkCachedUpdates()
    },
    unmounted() {
        window.removeEventListener('offline', this.onConnectivityChange)
        window.removeEventListener('online', this.onConnectivityChange)
    },
    computed: {
        isDeleteAllowed(): boolean {
            if (this.reportId === null) {
                return false
            }

            return this.isOnline || !!OfflineDataFetcher.isTemporaryId(this.reportId)
        },
        isNewReportNotSynchronized(): boolean {
            if(this.reportId) {
                return !!OfflineDataFetcher.isTemporaryId(this.reportId)
            }

            return false
        },
    },
    methods: {
        onConnectivityChange() {
            this.isOnline = window.navigator.onLine
        },
        async checkCachedUpdates() {
            if(this.reportId) {
                this.reportHasCachedUpdate = await this.$conditionReportDataStore.hasCachedUpdates(this.reportId)
            }
        },
        saveReport() {
            if(this.canEdit) {
                this.emitOnBus(SAVE_CURRENT_REPORT_TOPIC)
                this.emitOnBus(TOGGLE_MENU_TOPIC)
            }
        },
        deleteModificationsNotSynchronized() {
            this.emitOnBus(DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
        openReportOverview() {
            this.emitOnBus(OPEN_PDF_OVERVIEW_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
        openSignatureModule() {
            this.emitOnBus(OPEN_SIGNATURE_MODULE_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
        openCounterSignatureModule() {
            this.emitOnBus(OPEN_COUNTER_SIGNATURE_MODULE_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
        openCloseModuleScreen() {
            this.emitOnBus(OPEN_CLOSE_REPORT_SCREEN_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
        showDeleteConfirmation(value: boolean) {
            this.isConfirmationDeleteReportVisible = value
        },
        showDeleteUnsyncModifConfirmation(value: boolean) {
            this.isConfirmationDeleteUnsyncModifVisible = value
        },
        deleteReport() {
            this.emitOnBus(TOGGLE_MENU_TOPIC)
            this.emitOnBus(DELETE_CURRENT_REPORT_TOPIC)
            this.$router.push({ name: ConditionReportRoutes.CONDITION_REPORT_HOME })
        },
        duplicateClosedReport() {
            this.emitOnBus(TOGGLE_MENU_TOPIC)
            this.emitOnBus(DUPLICATE_CLOSED_REPORT_TOPIC)
        },
        onMediaStartLoading() {
            this.canEdit = false
        },
        onMediaEndLoading() {
            this.canEdit = true
        },
    },
    watch: {
        reportId() {
            this.checkCachedUpdates()
        },
    },
})
